module.exports = __webpack_public_path__ + "static/media/RATATTACK_en.55730afd.pdf";